import { render, staticRenderFns } from "./srCodeDialog.vue?vue&type=template&id=c1018556&"
import script from "./srCodeDialog.vue?vue&type=script&lang=js&"
export * from "./srCodeDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports